import {rpAppLink} from "@pg-mono/rp-routes";
import {navigationLinks} from "@pg-rp/navigation";

const {academyRealEstateLink, voxCrmLink} = navigationLinks;

export interface ICompanyLogo {
    name: string;
    href: string;
    logoDesktop: string;
    logoMobile: string;
    width: number;
    height: number;
    mobileWidth: number;
    mobileHeight: number;
}

export const companyLogos: ICompanyLogo[] = [
    {
        name: "GetHome",
        href: rpAppLink.external.getHome,
        logoDesktop: require("../images/property_group_logos/gethome.png"),
        logoMobile: require("../images/property_group_logos/gethome_mobile.png"),
        width: 184,
        height: 42,
        mobileWidth: 146,
        mobileHeight: 33
    },
    {
        name: "Esti CRM",
        href: rpAppLink.external.estiCrm,
        logoDesktop: require("../images/property_group_logos/esti_crm.png"),
        logoMobile: require("../images/property_group_logos/esti_crm_mobile.png"),
        width: 184,
        height: 48,
        mobileWidth: 146,
        mobileHeight: 38
    },
    {
        name: "Platforma Mieszkaniowa",
        href: rpAppLink.external.platformaMieszkaniowa,
        logoDesktop: require("../images/property_group_logos/platforma_mieszkaniowa.png"),
        logoMobile: require("../images/property_group_logos/platforma_mieszkaniowa_mobile.png"),
        width: 156,
        height: 65,
        mobileWidth: 146,
        mobileHeight: 61
    },
    {
        name: "Akademia RE",
        href: academyRealEstateLink,
        logoDesktop: require("../images/property_group_logos/akademia_re.png"),
        logoMobile: require("../images/property_group_logos/akademia_re_mobile.png"),
        width: 156,
        height: 60,
        mobileWidth: 132,
        mobileHeight: 51
    },
    {
        name: "Vox Developer",
        href: voxCrmLink,
        logoDesktop: require("../images/property_group_logos/voxvdeveloper.png"),
        logoMobile: require("../images/property_group_logos/voxvdeveloper_mobile.png"),
        width: 156,
        height: 90,
        mobileWidth: 132,
        mobileHeight: 76
    }
];
import {rpAppLink} from "@pg-mono/rp-routes";
import {navigationLinks} from "@pg-rp/navigation";

const {academyRealEstateLink, voxCrmLink} = navigationLinks;

export interface ICompanyLogo {
    name: string;
    href: string;
    logoDesktop: string;
    logoMobile: string;
    width: number;
    height: number;
    mobileWidth: number;
    mobileHeight: number;
}

export const companyLogos: ICompanyLogo[] = [
    {
        name: "GetHome",
        href: rpAppLink.external.getHome,
        logoDesktop: require("../images/property_group_logos/gethome.png"),
        logoMobile: require("../images/property_group_logos/gethome_mobile.png"),
        width: 184,
        height: 42,
        mobileWidth: 146,
        mobileHeight: 33
    },
    {
        name: "Esti CRM",
        href: rpAppLink.external.estiCrm,
        logoDesktop: require("../images/property_group_logos/esti_crm.png"),
        logoMobile: require("../images/property_group_logos/esti_crm_mobile.png"),
        width: 184,
        height: 48,
        mobileWidth: 146,
        mobileHeight: 38
    },
    {
        name: "Platforma Mieszkaniowa",
        href: rpAppLink.external.platformaMieszkaniowa,
        logoDesktop: require("../images/property_group_logos/platforma_mieszkaniowa.png"),
        logoMobile: require("../images/property_group_logos/platforma_mieszkaniowa_mobile.png"),
        width: 156,
        height: 65,
        mobileWidth: 146,
        mobileHeight: 61
    },
    {
        name: "Akademia RE",
        href: academyRealEstateLink,
        logoDesktop: require("../images/property_group_logos/akademia_re.png"),
        logoMobile: require("../images/property_group_logos/akademia_re_mobile.png"),
        width: 156,
        height: 60,
        mobileWidth: 132,
        mobileHeight: 51
    },
    {
        name: "Vox Developer",
        href: voxCrmLink,
        logoDesktop: require("../images/property_group_logos/voxvdeveloper.png"),
        logoMobile: require("../images/property_group_logos/voxvdeveloper_mobile.png"),
        width: 156,
        height: 90,
        mobileWidth: 132,
        mobileHeight: 76
    }
];
